<div [class]="theme ? theme : 'one-portal'">
  <mat-card class="mat-card--widget-order">
    <mat-card-content>
      <div class="container">
        <div class="row">
            <div class="col s12 text-center">
                <h3 class="text-upper">Shipping Label</h3>
            </div>
        </div>
        <div class="row">
          <div class="col s12">
            <mat-form-field>
              <mat-label>FROM</mat-label>
              <input type="text" matInput readonly [(ngModel)]="originInfo.businessName"/>
            </mat-form-field>
          </div>
          <div class="col s12">
            <mat-form-field>
              <mat-label>ADDRESS</mat-label>
              <input type="text" matInput readonly [(ngModel)]="originInfo.streetName" />
            </mat-form-field>
          </div>
          <div class="col m4 s12">
            <mat-form-field>
              <mat-label>CITY</mat-label>
              <input type="text" matInput readonly [(ngModel)]="originInfo.city" />
            </mat-form-field>
          </div>
          <div class="col m4 s12">
            <mat-form-field>
              <mat-label>STATE</mat-label>
              <input type="text" matInput readonly [(ngModel)]="originInfo.state" />
            </mat-form-field>
          </div>
          <div class="col m4 s12">
            <mat-form-field>
              <mat-label>ZIP CODE</mat-label>
              <input type="text" matInput readonly [(ngModel)]="originInfo.postalCode" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col s12">
            <mat-form-field>
              <mat-label>TO</mat-label>
              <input type="text" matInput readonly [(ngModel)]="destinationInfo.businessName" />
            </mat-form-field>
          </div>
          <div class="col s12">
            <mat-form-field>
              <mat-label>ADDRESS</mat-label>
              <input type="text" matInput readonly [(ngModel)]="destinationInfo.streetName" />
            </mat-form-field>
          </div>
          <div class="col m4 s12">
            <mat-form-field>
              <mat-label>CITY</mat-label>
              <input type="text" matInput readonly [(ngModel)]="destinationInfo.city" />
            </mat-form-field>
          </div>
          <div class="col m4 s12">
            <mat-form-field>
              <mat-label>STATE</mat-label>
              <input type="text" matInput readonly [(ngModel)]="destinationInfo.state" />
            </mat-form-field>
          </div>
          <div class="col m4 s12">
            <mat-form-field>
              <mat-label>ZIP CODE</mat-label>
              <input type="text" matInput readonly [(ngModel)]="destinationInfo.postalCode" />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
            <div class="col s12 text-center">
              <button class="btn btn-primary cancel-btn" aria-label="Cancel" (click)="closeDialog()" type="button">
                Cancel
              </button>
                <button class="btn btn-primary" aria-label="Create Shipping Label" (click)="createShippingLabel()" type="button">
                    Create Shipping Label
                  </button>
            </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>